import React, { useEffect, useState } from "react"

//Steps
import MultiType from "./MultiType"
import MultiCic from "./MultiCic"
import MultiGrouping from "./MultiGrouping"
import MultiSmoke from "./MultiSmoke"
import MultiCover from "./MultiCover"
import MultiPerson from "./MultiPerson"
import MultiDOB from "./MultiDOB"
import MultiContact from "./MultiContact"

//UI
import { Container, Button, Row, Col, Form, ProgressBar } from "react-bootstrap"

//Validation
import {
  addValidationErrorElement,
  removeValidationErrorElement,
} from "./Validation"

//Form function
import useForm from "../useForm"
import { insuranceType } from "../../data/formOptions"

const Multi = props => {
  const {
    values,
    handleChange,
    handleSubmit,
    setType,
    setCic,
    setGrouping,
    setSmoker,
    handleTermChange,
    disabled,
  } = props
  const [step, setStep] = useState(0)
  const [validationErrors, setValidationErrors] = useState({
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: ["firstName", "lastName"],
    6: ["dobDay", "dobMonth", "dobYear"],
    7: ["postcode", "phone", "email"],
  })
  // const { setErrorMessage } = props

  const isStepValid = () => {
    return validationErrors[step].length === 0
  }

  const nextStep = () => {
    if (!isStepValid()) {
      return false
    }

    // sleep()
    let tempStep = step
    tempStep++
    setStep(tempStep)
    // setJsx(steps[tempStep].jsx)
    // console.log(document.activeElement.id)
    // document.activeElement.blur()
    document.getElementById("multi-focus").focus()
  }

  const previousStep = () => {
    // if (!isStepValid()) {
    //   return false
    // }

    let tempStep = step
    tempStep--
    setStep(tempStep)
  }

  const addValidationError = (msg, id) => {
    //we don't need to do anything if an error exists
    if (validationErrors[step].includes(id)) {
      //we do this here as well as at the bottom of the func so we can make the startup error process work
      addValidationErrorElement(msg, id)
      return
    }

    //add to error
    let temp = { ...validationErrors }
    // temp.push(id)

    if (!temp[step]) {
      temp[step] = [id]
    } else {
      if (!temp[step].includes(id)) {
        temp[step] = [...temp[step], id]
      }
    }

    setValidationErrors(temp)
    addValidationErrorElement(msg, id)
  }

  const removeValidationError = id => {
    if (!validationErrors[step]) {
      return
    }

    //invalid call
    if (!validationErrors[step].includes(id)) {
      return
    }

    let temp = validationErrors
    // delete temp[step][id]
    const index = temp[step].indexOf(id)
    if (index > -1) {
      temp[step].splice(index, 1)
    }

    setValidationErrors(temp)
    removeValidationErrorElement(id)
  }

  let steps = {
    0: {
      jsx: (
        <MultiType
          values={values}
          setType={setType}
          nextStep={nextStep}
        ></MultiType>
      ),
      show_next_button: false,
      addIDsToErrorsOnLoad: [],
      show_submit_button: false,
    },
    1: {
      jsx: (
        <MultiCic
          values={values}
          setCic={setCic}
          nextStep={nextStep}
        ></MultiCic>
      ),
      show_next_button: false,
      addIDsToErrorsOnLoad: [],
      show_submit_button: false,
    },
    2: {
      jsx: (
        <MultiGrouping
          values={values}
          setGrouping={setGrouping}
          nextStep={nextStep}
        ></MultiGrouping>
      ),
      show_next_button: false,
      addIDsToErrorsOnLoad: [],
      show_submit_button: false,
    },
    3: {
      jsx: (
        <MultiSmoke
          values={values}
          setSmoker={setSmoker}
          nextStep={nextStep}
        ></MultiSmoke>
      ),
      show_next_button: false,
      addIDsToErrorsOnLoad: [],
      show_submit_button: false,
    },
    4: {
      jsx: (
        <MultiCover
          values={values}
          nextStep={nextStep}
          handleChange={handleChange}
          handleTermChange={handleTermChange}
        ></MultiCover>
      ),
      show_next_button: true,
      addIDsToErrorsOnLoad: [],
      show_submit_button: false,
    },
    5: {
      jsx: (
        <MultiPerson
          values={values}
          nextStep={nextStep}
          handleChange={handleChange}
          addValidationError={addValidationError}
          removeValidationError={removeValidationError}
        ></MultiPerson>
      ),
      show_next_button: true,
      show_submit_button: false,
    },
    6: {
      jsx: (
        <MultiDOB
          values={values}
          nextStep={nextStep}
          handleChange={handleChange}
          addValidationError={addValidationError}
          removeValidationError={removeValidationError}
        ></MultiDOB>
      ),
      show_next_button: true,
      show_submit_button: false,
    },
    7: {
      jsx: (
        <MultiContact
          values={values}
          nextStep={nextStep}
          handleChange={handleChange}
          addValidationError={addValidationError}
          removeValidationError={removeValidationError}
        ></MultiContact>
      ),
      show_next_button: false,
      show_submit_button: true,
    },
  }

  const [compomentAmt] = useState(Object.keys(steps).length)
  const [progressAmt, setProgressAmt] = useState(0)

  useEffect(() => {
    // setJsx(steps[step].jsx)
    if (step < compomentAmt) {
      setProgressAmt((step / compomentAmt) * 100)
    } else if (step === compomentAmt) {
      setProgressAmt(100)
    }
  }, [step])

  return (
    <Form id="form" onSubmit={handleSubmit} autoComplete="on">
      <ProgressBar
        // className="progress-bar"
        variant="info"
        now={progressAmt}
        // style={{ backgroundColor: "#fe9900!important" }}
      ></ProgressBar>
      <br></br>
      <Container>
        <Row>
          <input type="hidden" id="multi-focus"></input>
          <Col>{steps[step].jsx}</Col>
        </Row>
        {/* <hr></hr> */}
        <Row>
          {step > 0 ? (
            <Col xs={6}>
              <Button
                className="btn btn-warning back-btn fa-solid fa-circle-arrow-left btn btn-primary back-next-btn"
                onClick={() => previousStep()}
                // disabled={!isStepValid()}
              ></Button>
            </Col>
          ) : null}
          {/* continue button is only shown on input type  */}
          {steps[step].show_next_button ? (
            <Col xs={6}>
              <Button
                className="btn btn-warning next-btn fa-solid fa-circle-arrow-right btn btn-primary float-right"
                onClick={() => nextStep()}
                disabled={!isStepValid()}
              ></Button>
            </Col>
          ) : null}
        </Row>
        {steps[step].show_submit_button ? (
          <Row style={{ textAlign: "center" }}>
            <Col className="col">
              <Button
                className="compare-orange-btn"
                disabled={!isStepValid()}
                type="submit"
                form="form"
                disabled={disabled}
              >
                {/* -----------------DESKTOP----------------- */}
                <div className="d-block d-sm-none">
                  <h6>
                    <strong>Compare Quotes Now >></strong>
                  </h6>
                </div>
                {/* -----------------MOBILE-----------------*/}
                <div className="d-none d-sm-block">
                  <h6>Compare Quotes Now >></h6>
                </div>
              </Button>
            </Col>
          </Row>
        ) : null}
      </Container>
    </Form>
  )

  // return steps[step].jsx
}

export default Multi
